// redux/actions/confirmationDialogActions.ts
export const SHOW_DIALOG = "SHOW_DIALOG";
export const CLOSE_DIALOG = "CLOSE_DIALOG";

export interface ConfirmationDialogPayload {
  id?: string;
  title?: string;
  content?: string | React.ReactNode;
  value?: "info" | "warn" | "error" | "delete";
  labelOk?: string;
  labelCancel?: string;
  component?: React.ReactNode;
}

export const showDialog = (payload: ConfirmationDialogPayload) => ({
  type: SHOW_DIALOG,
  payload,
});

export const closeDialog = () => ({
  type: CLOSE_DIALOG,
});
